import { Status as UIStatus } from '@gogame/components';

import { STATUS_ERROR, STATUS_SEND } from '../constants';

export const Status = ({ id }) => {
  switch (id) {
    case STATUS_SEND:
      return <UIStatus color={'success'}>{id}</UIStatus>;
    case STATUS_ERROR:
      return <UIStatus color={'error'}>{id}</UIStatus>;
    default:
      return <UIStatus color={'info'}>{id}</UIStatus>;
  }
};
